import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractAddendum } from "../../../../models/Entities/Contracts/ContractAddendum";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { ErrorType } from "../../../../models/HttpError";
import { Protocol } from "../../../../models/Entities/Protocols/Protocol";

// stores
import * as ContractBranchStore from '../../../../redux/middleware/ContractBranchsMiddleware';
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware';

//State
import { AppState } from "../../../../redux/reducers";


interface IProps {
    isOpen: boolean;
    dismissPanel: () => void;
    ContractId: number;
    ContractAddendumId: number;
    ContractBranchId: number | undefined;
}

interface ConnectedProps {
    // loading
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    failOnLoading: boolean;

    // adding
    isAddingNewOne: boolean;
    isAddedSuccessfully: boolean;
    failOnAdding: boolean;

    error: ErrorType | undefined;

    Contract: Contract | undefined;
    Branch: ContractBranch | undefined;
    Protocols: Protocol[] | undefined;
}

interface DispatchProps {
    GetContractBranchById: typeof ContractBranchStore.actionCreators.GetContractBranchById;
    CreateContractBranch: typeof ContractBranchStore.actionCreators.CreateContractBranch;
    UpdateContractBranch: typeof ContractBranchStore.actionCreators.UpdateContractBranch;
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    // Current contract 
    var CurrentContract: Contract | undefined = undefined;
    if (ownProps.ContractId && state.Contract && state.Contract?.list) {
        CurrentContract = state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId);
    }

    // Current addendum
    var CurrentAddendum: ContractAddendum | undefined = undefined;
    if (CurrentContract && ownProps.ContractAddendumId) {
        CurrentAddendum = CurrentContract.addendums?.find((addendum: ContractAddendum) => addendum.id === ownProps.ContractAddendumId);
    }

    // Current branch
    var CurrentBranch: ContractBranch | undefined = undefined;
    if (CurrentAddendum && ownProps.ContractBranchId) {
        CurrentBranch = CurrentAddendum.branches?.find((branch: ContractBranch) => branch.id === ownProps.ContractBranchId);
    }

    return {
        isLoading: state.ContractBranch?.isLoadingAll,
        isUpdating: state.ContractBranch?.isLoadingAll,
        isUpdatedSuccessfully: state.ContractBranch?.isUpdatingAllSuccess,
        isLoadingSuccessfully: state.ContractBranch?.successLoadingAll,
        isAddingNewOne: state.ContractBranch?.isAddingNewOne,
        isAddedSuccessfully: state.ContractBranch?.successAddingNewOne,
        failOnAdding: state.ContractBranch?.failOnAddingNewOne,
        failOnLoading: state.ContractBranch?.failOnLoadingAll,
        AddRangeFinalized: state.ContractBranch?.isAddingFinishedSuccessfully,
        isDeleting: state.ContractBranch?.isDeletingOne,
        isDeletedSuccessfully: state.ContractBranch?.successDeletingOne,
        failOnDeleting: state.ContractBranch?.failOnDeletingOne,
        error: state.ContractBranch?.error,
        Contract: ownProps.ContractId && state.Contract && state.Contract?.list ? state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId) : undefined,
        Branch: ownProps.ContractBranchId && CurrentBranch ? CurrentBranch : undefined,
        Protocols: state.MedicalProtocols?.list
    }
};

export const mapDispatchToProps = {
    ...ContractBranchStore.actionCreators,
    ...ContractStore.actionCreators
};